var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrbit = function SvgOrbit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B0C9E2",
    d: "M6.25 12a5.75 5.75 0 1 1 11.5 0 5.75 5.75 0 0 1-11.5 0M18.138 3.976a2.75 2.75 0 1 1 3.724 4.048 2.75 2.75 0 0 1-3.724-4.048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#004280",
    d: "M3.205 12A8.795 8.795 0 0 1 12 3.205c2.042 0 3.92.694 5.413 1.862a2.76 2.76 0 0 1 1.275-1.484A10.7 10.7 0 0 0 12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12q0-.543-.053-1.074a.977.977 0 0 0-1.945.193q.044.435.044.881a8.796 8.796 0 0 1-17.591 0"
  })));
};
export default SvgOrbit;